jQuery(document).ready(function () {
  jQuery('html body').on('click', '.cart__checkout', function(){
    var checkout_url = jQuery(this).data('route-href');
    document.location.href = checkout_url;
  });
})




// Wishlist Functions

$(document).ready(function() {
    $('.variant-selector').change(function() {
        updateWishlistUI();
    });

    $('.wishlist-btn').click(function() {
        var productId = $(this).data('product-id');
        var variantId = $(this).data('variant-id');
        var variantImage = $(this).data('variant-image');
        var variantName = $(this).data('variant-name');
        var productName = $(this).data('product-name');
        var productUrl = $(this).data('product-url');
        var productType = $(this).data('product-type');
        var productDirect = $(this).data('product-direct');
        
        var wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];
        var item = {
            productId: productId,
            variantId: variantId,
            variantImage: variantImage,
            productName: productName,
            variantName: variantName,
            productUrl: productUrl,
            productType: productType,
            productDirect: productDirect
        };

        var existingIndex = wishlist.findIndex(function(item) {
            return item.productId === productId && item.variantId === variantId;
        });

        if (existingIndex !== -1) {
            wishlist.splice(existingIndex, 1);
        } else {
            wishlist.push(item);
        }

        localStorage.setItem('wishlist', JSON.stringify(wishlist));
        updateWishlistUI();
    });

    // Handle Remove Item from Wishlist
    $(document).on('click', '.remove-btn', function() {
        var productId = $(this).data('product-id');
        var variantId = $(this).data('variant-id');
        var productDirect = $(this).data('product-direct');
        
        var wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];
        
        if (productDirect === 'yes') {
            // Remove by productId only
            wishlist = wishlist.filter(function(item) {
                return item.productId !== productId;
            });
        } else {
            // Remove by productId and variantId
            wishlist = wishlist.filter(function(item) {
                return item.productId !== productId || item.variantId !== variantId;
            });
        }

        localStorage.setItem('wishlist', JSON.stringify(wishlist));
        updateWishlistUI();
    });

    function updateWishlistUI() {
        var wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];
        $('.wishlist-btn').each(function() {
            var productId = $(this).data('product-id');
            var variantId = $(this).data('variant-id');
            var productDirect = $(this).data('product-direct');
            var index;
            if (productDirect === 'yes') {
                index = wishlist.findIndex(function(item) {
                    return item.productId === productId;
                });
            } else {
                index = wishlist.findIndex(function(item) {
                    return item.productId === productId && item.variantId === variantId;
                });
            }
            if (index !== -1) {
                $(this).addClass('in-wishlist');
            } else {
                $(this).removeClass('in-wishlist');
            }
        });
    }

    updateWishlistUI();
});


//  Wishlist Popup
$(document).ready(function() {
    // Open Wishlist Popup Modal
    $('#viewWishlistBtn').click(function() {
        displayWishlist();
    });

    // Close Wishlist Popup Modal
    $('.close').click(function() {
        $('#wishlistModal').hide();
    });

    // Close Popup on Overlay Click
    $(window).click(function(event) {
        if (event.target.id == 'wishlistModal') {
            $('#wishlistModal').hide();
        }
    });

    // Remove Item from Wishlist
    $(document).on('click', '.remove-btn', function() {
        var variantId = $(this).data('variant-id');
        var productId = $(this).data('product-id');

        var wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];
        var updatedWishlist;

        // Filter out the item based on variantId and productId
        updatedWishlist = wishlist.filter(function(item) {
            if (variantId !== "undefined") {
                
                return item.variantId !== variantId || item.productId !== productId;
            } else {
                return item.productId !== productId;
            }
        });

        localStorage.setItem('wishlist', JSON.stringify(updatedWishlist));
        displayWishlist();
        updateWishlistCounter();
    });

    // Display Wishlist Items in Popup
    function displayWishlist() {
        var wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];
        var wishlistItemsHTML = '';

        wishlist.forEach(function(item) {
            wishlistItemsHTML += `
                <div class="wishlist-item">
                    <a href="${item.productUrl}">
                        <img src="${item.variantImage}" alt="${item.productName}">
                    </a>
                    <div class="wishlist-info">
                        <h3><a href="${item.productUrl}">${item.productName}</a></h3>
                        
                        <button class="remove-btn" data-variant-id="${item.variantId}" data-product-id="${item.productId}">Remove</button>
                    </div>
                </div>
            `;
        });

        $('#wishlistItems').html(wishlistItemsHTML);
        $('#wishlistModal').show();
    }

    // Update Wishlist Counter
    function updateWishlistCounter() {
        var wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];
        $('#wishlistCounter').text(wishlist.length);
    }

    // Initial Counter Update
    updateWishlistCounter();
});
